import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1bc4575f&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=1bc4575f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc4575f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\华水\\hsmanagementsystem\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bc4575f')) {
      api.createRecord('1bc4575f', component.options)
    } else {
      api.reload('1bc4575f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1bc4575f&scoped=true", function () {
      api.rerender('1bc4575f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hdyblstj/index.vue"
export default component.exports